import { IFilters, ISort } from 'core/actions/Actions.interfaces'
import { defaultListParams } from 'core/utils/constants'
import { actionErrorNotifier } from 'core/utils/helpers'
import { actionCoreApi } from 'core/utils/api'
import { ActionType, dispatcherActionType } from 'core/utils/interfaces'
import { ClientAuthActions } from './ClientAuth.constants'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import { EnableCertRequestPayload } from './ClientAuth.types'

export const fetchClientAuthCerts = (params: ISort = defaultListParams, id: string, filters?: IFilters): ActionType =>
  actionErrorNotifier(actionCoreApi(
    ClientAuthActions.FetchClientAuthCerts,
    HTTPUrlHelper.getClientAuthCertsAPI(params, id, filters)
  ))

  export const enableCertificateForUser = (payload: EnableCertRequestPayload, id: string, userId: string, type: string): dispatcherActionType => actionErrorNotifier(
    actionCoreApi(
        ClientAuthActions.EnableClientAuthCert,
      type === 'service' ? HTTPUrlHelper.enableClientAuthCertServiceUserAPI(id, userId) : HTTPUrlHelper.enableClientAuthCertAPI(id, userId),
      'PUT',
      payload
    ), true,
    {
      title: '',
      message: 'notifications.clientAuth.statusChangeSuccess'
    }
  )